import { ssv2300ConfiOpedaWsResource } from '@/shared/api.resource';

import {
  FETCH_SSV2300_CONFI_OPEDA_WS_BY_ID,
  FETCH_PAGINATED_SSV2300_CONFI_OPEDA_WSS,
  UPDATE_SSV2300_CONFI_OPEDA_WS,
  CREATE_SSV2300_CONFI_OPEDA_WS,
  DELETE_SSV2300_CONFI_OPEDA_WS,
  RESET_SSV2300_CONFI_OPEDA_WS_FILTERS,
  RESET_SSV2300_CONFI_OPEDA_WS,
  RESET_SSV2300_CONFI_OPEDA_WSS_LIST,
} from './actions.type';

import {
  SET_SSV2300_CONFI_OPEDA_WS,
  SET_PAGINATED_SSV2300_CONFI_OPEDA_WSS,
  RESET_STATE_SSV2300_CONFI_OPEDA_WS_FILTERS,
  RESET_STATE_SSV2300_CONFI_OPEDA_WS,
  RESET_STATE_SSV2300_CONFI_OPEDA_WS_LIST,
} from './mutations.type';

const initialState = {
  ssv2300ConfiOpedaWsFilters: {},
  ssv2300ConfiOpedaWs: {},
  paginatedSsv2300ConfiOpedaWss: {
    content: [],
    totalElements: 0,
    size: 0
  }
};

export const state = JSON.parse(JSON.stringify(initialState));

export const actions = {
  async [FETCH_SSV2300_CONFI_OPEDA_WS_BY_ID](context, id) {
    const { data } = await ssv2300ConfiOpedaWsResource.get({ id: id });
    context.commit(SET_SSV2300_CONFI_OPEDA_WS, data);
    return data;
  },
  async [FETCH_PAGINATED_SSV2300_CONFI_OPEDA_WSS](context, params) {
    const { data } = await ssv2300ConfiOpedaWsResource.query(params);
    context.commit(SET_PAGINATED_SSV2300_CONFI_OPEDA_WSS, data);
    return data;
  },
  async [CREATE_SSV2300_CONFI_OPEDA_WS](context) {
    const { data } = await ssv2300ConfiOpedaWsResource.save(state.ssv2300ConfiOpedaWs);
    context.commit(SET_SSV2300_CONFI_OPEDA_WS, data);
    return data;
  },
  async [UPDATE_SSV2300_CONFI_OPEDA_WS](context, id) {
    const { data } = await ssv2300ConfiOpedaWsResource.update({ id: id }, state.ssv2300ConfiOpedaWs);
    context.commit(SET_SSV2300_CONFI_OPEDA_WS, data);
    return data;
  },
  [DELETE_SSV2300_CONFI_OPEDA_WS](context, id) {
    return ssv2300ConfiOpedaWsResource.delete({ id: id });
  },
  [RESET_SSV2300_CONFI_OPEDA_WS_FILTERS]({ commit }) {
    commit(RESET_STATE_SSV2300_CONFI_OPEDA_WS_FILTERS);
  },
  [RESET_SSV2300_CONFI_OPEDA_WS]({ commit }) {
    commit(RESET_STATE_SSV2300_CONFI_OPEDA_WS);
  },
  [RESET_SSV2300_CONFI_OPEDA_WSS_LIST]({ commit }) {
    commit(RESET_STATE_SSV2300_CONFI_OPEDA_WS_LIST);
  }
};

export const mutations = {
  [SET_SSV2300_CONFI_OPEDA_WS](state, ssv2300ConfiOpedaWs) {
    state.ssv2300ConfiOpedaWs = ssv2300ConfiOpedaWs;
  },
  [SET_PAGINATED_SSV2300_CONFI_OPEDA_WSS](state, paginatedSsv2300ConfiOpedaWss) {
    state.paginatedSsv2300ConfiOpedaWss = paginatedSsv2300ConfiOpedaWss;
  },
  [RESET_STATE_SSV2300_CONFI_OPEDA_WS](state) {
    state.ssv2300ConfiOpedaWs = JSON.parse(JSON.stringify(initialState.ssv2300ConfiOpedaWs));
  },
  [RESET_STATE_SSV2300_CONFI_OPEDA_WS_FILTERS](state) {
    state.ssv2300ConfiOpedaWsFilters = JSON.parse(JSON.stringify(initialState.ssv2300ConfiOpedaWsFilters));
  },
  [RESET_STATE_SSV2300_CONFI_OPEDA_WS_LIST](state) {
    state.paginatedssv2300ConfiOpedaWss = JSON.parse(JSON.stringify(initialState.paginatedSsv2300ConfiOpedaWss));
  }
};

export const getters = {
  ssv2300ConfiOpedaWs(state) {
    return state.ssv2300ConfiOpedaWs;
  },
  ssv2300ConfiOpedaWsFilters(state) {
    return state.ssv2300ConfiOpedaWsFilters;
  },
  paginatedSsv2300ConfiOpedaWss(state) {
    return state.paginatedSsv2300ConfiOpedaWss;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
}